module.exports = "/_next/static/images/prateek-d98466cd3a120fdffc4791bb6d364c45.png";